// What finalizing does with the shops on an invoice that no longer pass the Ready for Invoicing rules.
const FinalizeJobsNoLongerReadyChoiceEnum = {
  Remove: 'Remove',
  Keep: 'Keep',
};

export default FinalizeJobsNoLongerReadyChoiceEnum;
